/* eslint-disable max-lines */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { overridePrescription } from 'store/thunks/workQueueThunks';

const ResolveAsIsButton = ({ patientId, lineItemId, prescriptionUUID, sx }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [showResolveAsIsModal, setShowResolveAsIsModal] = useState(false);

  const handleCloseModal = () => setShowResolveAsIsModal(false);
  const openResolveAsIsModal = () => setShowResolveAsIsModal(true);

  const handleConfirmResolveAsIs = () => {
    setIsLoading(true);
    const overridePrescriptionPayload = {
      input: {
        resolveAsIs: true,
        lineItemId,
        patientId,
        prescriptionUUID,
      },
    };

    dispatch(
      overridePrescription({
        input: overridePrescriptionPayload,
        fromWorkQueue: true,
        isPrescriptionEdit: false,
        isFillEdit: false,
      })
    )
      .then((success) => {
        if (!isEmpty(success)) {
          enqueueSnackbar('Prescription has been resolved successfully', {
            variant: 'success',
          });
        } else {
          enqueueSnackbar('Resolve prescription failed', { variant: 'error' });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <Dialog open={showResolveAsIsModal}>
        <DialogTitle>Resolve prescription</DialogTitle>

        <DialogContent sx={{ minWidth: 600 }}>
          <Typography variant='subtitle1' sx={{ my: 2 }}>
            Are you sure you want to proceed? Resolving this item as-is will revert any changes made
            during the review and return it to its pre-review state.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseModal} variant='outlined' color='secondary' sx={{ mr: 1 }}>
            Cancel
          </Button>
          <LoadingButton
            variant='contained'
            color='error'
            loading={isLoading}
            onClick={handleConfirmResolveAsIs}
          >
            Confirm
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <Button
        size='small'
        sx={{
          mr: 2,
          px: 1,
          minHeight: 30,
          fontSize: '0.75rem',
          lineHeight: 'normal',
          minWidth: 'auto',
          textTransform: 'none',
          ...sx,
        }}
        variant='outlined'
        color='warning'
        onClick={openResolveAsIsModal}
      >
        Resolve As-Is
      </Button>
    </>
  );
};

export default ResolveAsIsButton;

ResolveAsIsButton.propTypes = {
  patientId: PropTypes.string.isRequired,
  lineItemId: PropTypes.string.isRequired,
  prescriptionUUID: PropTypes.string.isRequired,
  sx: PropTypes.shape({}),
};

ResolveAsIsButton.defaultProps = {
  sx: {},
};
